import styled from "styled-components";
import {
  COLORS,
  TYPOGRAPHY,
  BREAKPOINTS
} from "containers/impact-report/constants";

export const TextDetailSection = styled.section`
  background-color: ${COLORS.BG_COLOR};

  @media (min-width: ${BREAKPOINTS.MD}) {
    text-align: center;
  }
`;

export const ContentWrapper = styled.div`
  padding: 60px 24px;

  @media (min-width: ${BREAKPOINTS.MD}) {
    padding: 100px 0;
    max-width: 660px;
    margin: 0 auto;
  }
`;

export const SectionTitle = styled.h1`
  ${TYPOGRAPHY.H1_MOBILE}
  color: ${COLORS.NEUTRAL_500};
  margin: 0 0 16px 0;

  @media (min-width: ${BREAKPOINTS.MD}) {
    ${TYPOGRAPHY.H1_DESKTOP}
    margin: 0 0 24px 0;
  }
`;

export const MainHeading = styled.h2`
  ${TYPOGRAPHY.H2_MOBILE}
  color: ${COLORS.NEUTRAL_500};
  margin: 0 0 24px 0;

  @media (min-width: ${BREAKPOINTS.MD}) {
    ${TYPOGRAPHY.H2_DESKTOP}
    margin: 0 0 40px 0;
  }
`;

export const BodyText = styled.p`
  ${TYPOGRAPHY.BODY_LARGE_LIGHT}
  color: ${COLORS.NEUTRAL_500};
  margin: 0 0 16px 0;

  &:last-child {
    margin-bottom: 0;
  }

  @media (min-width: ${BREAKPOINTS.MD}) {
    ${TYPOGRAPHY.P_DESKTOP}
    margin: 0 0 24px 0;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
